import { z } from 'zod';

export type YesOrNo = z.infer<typeof YesOrNoSchema>;

export type Version = z.infer<typeof VersionSchema>;

export type DataSet = z.infer<typeof DataSetSchema>;

export const YesOrNoSchema = z.enum(['Yes', 'No']);

export const VersionSchema = z.literal('6.0.0');

export const DataSetSchema = z.literal('01');
